import contextSectionNavigation from '@contexts/sectionNavigation'
import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import Section from '@components/SectionNavigation'
import { SectionNavigationAPIProps } from './types'

const { SectionNavigationContext } = contextSectionNavigation

const SectionNavigation: FunctionComponent<SectionNavigationAPIProps> = ({
  section,
  subsections,
  blockType,
}) => {
  const { name } = section
  const isVideoBlock = blockType === 'video'
  const isMondovino = name.includes('Wein') || name === 'Vin'

  return (
    <SectionNavigationContext.Provider value={{ isVideoBlock, isMondovino }}>
      <Section section={section} subsections={subsections} />
    </SectionNavigationContext.Provider>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'section-navigation'],
  component: SectionNavigation,
}

export default widget
